export const getGitlabPipelineUrl = (buildId: string): string => {
  return `https://gitlab.heidelbergcement.com/hcp/monorepo/pipelines/${buildId}`
}
